export default "__VITE_ASSET__Nkm0D9ik__"